import LearnerLevelLabel from './LearnerLevelLabel'

export default LearnerLevelLabel
